import { FaAnglesLeft, FaAnglesRight, FaChevronLeft, FaChevronRight, FaClock, FaPowerOff, FaSignal, FaTrashCan } from "react-icons/fa6";
import { getRxPowerColorComponent } from "../components/GetRxPowerColor";
import { formatDate } from "../../../../utilities/formatDate";
import { GenieAcsSkeletonRowComponent } from "../components/SkeletonRow";
import { useNavigate } from "react-router-dom";
import { GenieAcsStatusBadgeComponent } from "../components/StatusBadge";
import { getPaginationPagesComponent } from "../components/GetPaginationPage";

export const GenieAcsDesktopTableSection = ({ loading, itemsPerPage, data, handleAction, handlePageChange, currentPage, totalPages }) => {

    /* ---------- Column Config (Status di depan) ---------- */
    const columns = [
        { key: "status", label: "Status", width: "110px" }, // Pindah ke depan
        { key: "customerId", label: "ID Pel", align: "left", width: "130px" },
        { key: "customerName", label: "Nama Pelanggan", align: "left" },
        { key: "ip", label: "IP Address", align: "left", width: "140px" },
        { key: "model", label: "Model", align: "left" },
        { key: "rxPower", label: "Rx Power", align: "left", width: "100px" },
        { key: "lastInform", label: "Terakhir Aktif", align: "left" },
        { key: "action", label: "Aksi", align: "center", width: "100px" },
    ];

    const navigate = useNavigate();

    return (
        <section
            className="hidden lg:block rounded-2xl overflow-hidden"
            style={{
                background: "rgba(15, 23, 42, 0.6)",
                border: "1px solid rgba(51, 65, 85, 0.4)",
            }}
        >
            <div className="overflow-x-auto">
                <table className="w-full text-sm text-left">
                    <thead>
                        <tr
                            className="border-b"
                            style={{ background: "rgba(15, 23, 42, 0.8)", borderColor: "rgba(51, 65, 85, 0.4)" }}
                        >
                            {columns.map((col) => (
                                <th
                                    key={col.key}
                                    className={`px-4 py-3.5 text-xs font-semibold uppercase tracking-wider text-slate-400 ${col.align === "center" ? "text-center" : ""
                                        }`}
                                    style={col.width ? { width: col.width } : {}}
                                >
                                    {col.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-700/30">
                        {loading ? (
                            [...Array(5)].map((_, i) => <GenieAcsSkeletonRowComponent key={i} cols={columns.length} />)
                        ) : data && data?.length === 0 ? (
                            <tr>
                                <td colSpan={columns.length} className="px-4 py-12 text-center">
                                    <p className="text-slate-400">No devices found.</p>
                                </td>
                            </tr>
                        ) : (
                            data?.map((item, index) => (
                                <tr
                                    key={item._id}
                                    className="hover:bg-cyan-500/5 transition-colors group cursor-pointer"
                                    onClick={() => navigate(`/dashboard/genie-acs/detail/${item?.id_modem}`)}
                                >
                                    {/* 1. Status (Paling Depan) */}
                                    <td className="px-4 py-3">
                                        <GenieAcsStatusBadgeComponent status={item.status} />
                                    </td>

                                    {/* 2. ID Pelanggan */}
                                    <td className="px-4 py-3">
                                        <span className="font-mono text-xs text-slate-400">1234567890</span>
                                    </td>

                                    {/* 3. Nama Pelanggan */}
                                    <td className="px-4 py-3">
                                        {/* <div className="flex items-center gap-2">
                                            <div className="w-6 h-6 rounded-full bg-slate-700 flex items-center justify-center text-xs text-slate-300 font-bold">
                                                {item.customerName.charAt(0)}
                                            </div>
                                            <span className="font-medium text-slate-200">{item.customerName}</span>
                                        </div> */}
                                        {item?.tags && item?.tags.map((i) => (
                                            <span>{i}</span>
                                        ))}
                                    </td>

                                    {/* 4. IP Address */}
                                    <td className="px-4 py-3 font-mono text-xs text-slate-400">{item.ip_address}</td>

                                    {/* 5. Model */}
                                    <td className="px-4 py-3 text-slate-300">{item?.device_info?.product_class}</td>

                                    {/* 6. Rx Power (Baru) */}
                                    <td className="px-4 py-3 font-mono text-xs min-w-[150px]">
                                        <div className="flex items-center gap-2">
                                            <FaSignal className={`text-[10px] ${getRxPowerColorComponent(item.rx_power)}`} />
                                            <span className={getRxPowerColorComponent(item.rx_power)}>{item.rx_power} dBm</span>
                                        </div>
                                    </td>

                                    {/* 7. Last Inform */}
                                    <td className="px-4 py-3 text-xs text-slate-500">
                                        <div className="flex items-center gap-1.5">
                                            <FaClock className="text-[10px]" />
                                            {/* <span>{formatDate(item.lastInform)}</span> */}
                                            <span>{formatDate(item.last_inform)}</span>
                                        </div>
                                    </td>

                                    {/* 8. Action */}
                                    <td className="px-4 py-3">
                                        <div className="flex justify-center gap-1.5 opacity-60 group-hover:opacity-100 transition-opacity">
                                            <button
                                                onClick={(e) => { e.stopPropagation(); handleAction('reboot', item); }}
                                                className="p-2 rounded-lg text-slate-400 hover:text-cyan-400 hover:bg-slate-700/40 transition-all"
                                                title="Reboot"
                                            >
                                                <FaPowerOff className="text-sm" />
                                            </button>
                                            <button
                                                onClick={(e) => { e.stopPropagation(); handleAction('delete', item); }}
                                                className="p-2 rounded-lg text-slate-400 hover:text-red-400 hover:bg-slate-700/40 transition-all"
                                                title="Delete"
                                            >
                                                <FaTrashCan className="text-sm" />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination Desktop */}
            {totalPages > 1 && (
                <div className="flex items-center justify-between px-5 py-3.5 border-t border-slate-700/30">
                    <p className="text-xs text-slate-500">
                        Showing {(currentPage - 1) * itemsPerPage + 1} to {Math.min(currentPage * itemsPerPage, data?.length)} of {data?.length}
                    </p>
                    <nav className="flex items-center gap-1">
                        <button onClick={() => handlePageChange(1)} disabled={currentPage === 1} className="p-2 rounded-lg text-slate-400 hover:text-cyan-400 hover:bg-slate-700/40 disabled:opacity-30 transition-all">
                            <FaAnglesLeft className="text-xs" />
                        </button>
                        <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="p-2 rounded-lg text-slate-400 hover:text-cyan-400 hover:bg-slate-700/40 disabled:opacity-30 transition-all">
                            <FaChevronLeft className="text-xs" />
                        </button>
                        {getPaginationPagesComponent(totalPages, currentPage).map((p, i) => (
                            p === "..." ? (
                                <span key={i} className="px-2 text-slate-600 text-sm">...</span>
                            ) : (
                                <button
                                    key={p}
                                    onClick={() => handlePageChange(p)}
                                    className={`min-w-[34px] h-9 px-2 rounded-lg text-sm font-medium transition-all ${currentPage === p
                                        ? "bg-cyan-600 text-white shadow-lg shadow-cyan-600/25"
                                        : "text-slate-400 hover:text-slate-100 hover:bg-slate-700/40"
                                        }`}
                                >
                                    {p}
                                </button>
                            )
                        ))}
                        <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="p-2 rounded-lg text-slate-400 hover:text-cyan-400 hover:bg-slate-700/40 disabled:opacity-30 transition-all">
                            <FaChevronRight className="text-xs" />
                        </button>
                        <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} className="p-2 rounded-lg text-slate-400 hover:text-cyan-400 hover:bg-slate-700/40 disabled:opacity-30 transition-all">
                            <FaAnglesRight className="text-xs" />
                        </button>
                    </nav>
                </div>
            )}
        </section>
    )
}